import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import api from "@/app/api";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { Item } from "@/app/services/generated/itemService";
import { itemService } from "@/app/services/generated/itemService";

export interface IHasItemsCache {
  items: ItemsCache;
}

// Singleton cache store
const itemCacheStore = new EntityCacheStore<Item>(
  EnumCacheEntityType.item,
  async () => itemService.getAllItems(api.tenantId)
);

// Ephemeral reader
export default class ItemsCache extends EntityWithGuidKeyCache<Item> {
  _deliveryServices: readonly Item[] = [];
  _depositCharges: readonly Item[] = [];
  _depositRedemptionItem: Item | null = null;

  constructor() {
    super(itemCacheStore, (x) => x.details.id);
  }

  async update(): Promise<void> {
    await super.update();
    this._depositRedemptionItem =
      this.all.find((x) => x.details.mainPurpose.isBottleDepositRedemption()) ??
      null;

    this._deliveryServices = this.all.filter((x) =>
      x.details.mainPurpose.isDeliveryService()
    );

    this._depositCharges = this.all.filter((x) =>
      x.details.mainPurpose.isBottleDepositCharge()
    );
  }

  onlyBatchTracked() {
    return this.allReactive.value.filter(
      (item) => item.stock?.isBatchTracked ?? false
    );
  }

  products() {
    return this.allReactive.value.filter((item) =>
      item.details.mainPurpose.isProduct()
    );
  }

  get deliveryServices() {
    return this._deliveryServices;
  }

  get depositCharges() {
    return this._depositCharges;
  }

  get depositRedemptionItem() {
    return this._depositRedemptionItem;
  }

  get depositRedemptionItemId() {
    return this._depositRedemptionItem?.details.id ?? null;
  }
}
